/**
 * Esta funcion lee controles en pantalla y agrega sus valores en la URL
 */
function _updateURLOptions() {
  let showLabelItems = jQuery("#showLabelItems").is(":checked");
  let $url = "?";
  $url = $url + "&" + "sl=" + showLabelItems;

  let val = $('input[name="opcionVisualizacion_"]:checked').val();

  $url = $url + "&" + "mode=" + val;
  //checklist-filter-types
  val = jQuery(".checklist-filter-types").val();
  $url = $url + "&" + "t=" + val;
  val = jQuery(".checklist-filter-qualities").val();
  $url = $url + "&" + "q=" + val;
  window.history.pushState(null, null, $url);
}


function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * 
 Evaluar si aun se usan.
 */
function agregarIconoBoton(boton) {
    const icono = $("<i>").addClass("bi bi-check");
    $(boton).append(icono);
  }
  
  function quitarIconoBoton(boton) {
    $(boton).find("i").remove();
  }